import React, { useEffect, useMemo } from "react";
import MapComponent from "../../components/Map";
import DetectionActivity from "../../components/DetectionActivity";
import TrapStatus from "../../components/TrapStatus";
import ActivityDisplay from "../../components/ActivityDisplay";
import MaintenanceAlert from "../../components/Alerts/MaintenanceAlert";
import { Typography } from "antd";
import { BackButton } from "../../components/Specimen";
import { ROUTES } from "../../config/routes";
import { useNavigate, useParams } from "react-router-dom";
import { useListTrapSitesQuery } from "../../actions/trapsiteInQuery";

const { Title, Text } = Typography;

const LocationDetails: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const { data: trapSiteData } = useListTrapSitesQuery();

  const trapSite = useMemo(() => {
    if (!trapSiteData?.items || !id) return undefined;
    return trapSiteData.items.find((t) => t._id === id);
  }, [trapSiteData, id]);

  const trapSiteName = trapSite?.display_name ?? "Unassigned Location";
  const trapSiteAddress = trapSite?.address ?? "";

  return (
    <div className="home-container flex flex-col py-6">
      <div className="mx-6">
        <BackButton onClick={() => navigate(ROUTES.home)} />
      </div>
      <div className="mx-6">
        <Title level={2}>{trapSiteName}</Title>
        <Text className="block! -mt-2! mb-6!">{trapSiteAddress}</Text>
      </div>
      <div className="flex flex-row gap-4 mx-6 justify-center">
        <ActivityDisplay />
      </div>

      <div className="mx-6 flex gap-6 mt-0 h-150">
        <div className="w-3/6 shrink-0 h-full flex flex-col pt-6">
          <div className="h-1/2 pb-6">
            <DetectionActivity />
          </div>
          <div className="h-1/2 max-h-1/2 pb-6 ">
            <TrapStatus />
          </div>
        </div>
        <div className="flex-1 h-full">
          <MapComponent trapSite={trapSite} editable />
        </div>
      </div>

      <div className="mx-6 my-6">
        <MaintenanceAlert />
      </div>
    </div>
  );
};

export default LocationDetails;
